import Vue from 'vue';

import CustomLink from './CustomLink.vue';
Vue.component('CustomLink', CustomLink);
